<template>
  <div class="card">
    <div class="card-header">
      <slot name="header" />
    </div>
    <div class="card-body">
      <div class="form-group">
        <label class="ch-text">Wie möchten Sie bezahlen?</label>
        <div class="custom-controls-stacked">
          <div v-for="(type, index) in paymentAmount.types" :key="index" class="custom-control custom-radio">
            <input :id="'p-' + index" type="radio" class="custom-control-input" :value="type.id" :checked="paymentAmount.selected === type.id" @change="onSelectPaymentAmount">
            <label class="custom-control-label" :for="'p-' + index">
              <strong>{{ type.label }}</strong>
              <small v-if="type.id === 1 || paymentType.label !== 'Paypal'">
                ({{ type.sublabel }}
                <span v-if="type.customer_discount !== null">, {{ type.customer_discount }}<strong class="text-danger">{{ (price.total * type.discount / 100) | currency }}</strong></span>)
              </small>
              <fa icon="info-circle" />
            </label>
          </div>
        </div>
      </div>
      <hr>
      <div class="row">
        <div v-for="(type, index) in paymentsSorting" :key="index" class="col-md-6">
          <div class="custom-control custom-radio">
            <input :id="type.label" v-model="payment.selected" type="radio" class="custom-control-input" :value="type.id" @click="changePaymentType">
            <label :for="type.label" class="custom-control-label"><strong>{{ type.label }}</strong></label>
          </div>
          <div class="payment-text">
            {{ type.description }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'
export default {
  props: {
    additional: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      paymentAmount: 'checkout/paymentAmount',
      payment: 'checkout/payment',
      price: 'checkout/price',
      paymentType: 'checkout/paymentType'
    }),
    paymentsSorting () {
      return _.orderBy(this.payment.types, 'id', 'asc')
    }
  },
  methods: {
    ...mapActions({
      selectPaymentAmount: 'checkout/selectPaymentAmount',
      changePaymentType: 'checkout/changePaymentType'
    }),
    onSelectPaymentAmount (e) {
      this.selectPaymentAmount(Number.parseInt(e.target.value))
    }
  }
}
</script>
